module.exports = __webpack_public_path__ + "static/media/firstassister.ff2549b3.jpg";